var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import scrollLock from 'scroll-lock';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe.components/common/modal/modal.indra.service';
import { SidebarService } from '@ibe/services/ui';
var INDRASignupErrorModalComponent = /** @class */ (function (_super) {
    __extends(INDRASignupErrorModalComponent, _super);
    function INDRASignupErrorModalComponent(modalService, router, sidebarService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.router = router;
        _this.sidebarService = sidebarService;
        _this.htmlElement = document.getElementsByTagName('html');
        _this.TYPE = 'dialog';
        return _this;
    }
    INDRASignupErrorModalComponent.prototype.ngOnInit = function () {
    };
    INDRASignupErrorModalComponent.prototype.TAP_goWithoutDiscount = function () {
        this.modalService.close();
        this.sidebarService.closeSidebar();
    };
    INDRASignupErrorModalComponent.prototype.closeModal = function () {
        this.modalService.close();
        if (this.htmlElement[0].classList.contains('no-scroll')) {
            this.htmlElement[0].classList.remove('no-scroll');
            scrollLock.show();
        }
    };
    INDRASignupErrorModalComponent.prototype.TAP_newSearch = function () {
        this.modalService.close();
        this.sidebarService.closeSidebar();
    };
    return INDRASignupErrorModalComponent;
}(AbstractModalContentComponent));
export { INDRASignupErrorModalComponent };
